// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__1wP9-","rightAdornment":"Header_rightAdornment__1qXQK"};